import { useGetGalleryQuery } from '../../store';
import Button from '../shared/Button';
import Separator from '../shared/Separator';
import '../../resources/css/photo-blog.css';

export default function PhotoBlog({ data }) {

    const photosResult = useGetGalleryQuery();
    if (!photosResult?.data?.length) { return; }

    const renderedImages = photosResult.data.slice(0, 10).map(i => {
        return <img key={i.id} src={i.src} alt={i.title} ></img>;
    });

    return (
        <div>
            <div className="gallery-header">
                <div className="title-h1 color-white">{data.content.title}</div>
                <Separator className="color-white"></Separator>
            </div>
            <div className="gallery-body">{renderedImages}</div>
            <div className="gallery-footer">
                <Button href="/gallery" type="pure">{data.content.button}</Button>
            </div>
        </div>
    );
}